var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-fade" }, [
    _c(
      "p",
      { staticClass: "login-title" },
      [
        _vm.step === 0
          ? [_vm._v("Sign Up")]
          : [_vm._v("Just a few more details")]
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "login" }, [
      _c(
        "button",
        { staticClass: "login-close", on: { click: _vm.signUpClose } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "23",
                height: "23",
                viewBox: "0 0 23 23",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d: "M2.00342 2L20.6685 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M20.665 2L1.99993 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "login-form" }, [
        _vm.invited && _vm.inviter
          ? _c("div", { staticClass: "inviter" }, [
              _vm.inviter.profile_image
                ? _c("img", {
                    attrs: {
                      src: _vm.inviter.profile_image.url,
                      alt: "Inviter",
                      width: "49",
                      height: "49",
                      loading: "lazy"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "inviter-description" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.inviter.full_name) +
                    " has invited you to Pixchange!\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { id: "sign-form" },
            on: {
              submit: function($event) {
                return _vm.submitForm($event)
              }
            }
          },
          [
            _vm.step === 1
              ? [
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "input-icon",
                        attrs: {
                          width: "15",
                          height: "18",
                          viewBox: "0 0 15 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M7.49981 9.61661C9.55178 9.61661 11.2211 7.57516 11.2211 5.06578C11.2211 2.67411 9.69072 1.00391 7.49981 1.00391C5.3087 1.00391 3.77836 2.67411 3.77836 5.06578C3.77836 7.57516 5.44764 9.61661 7.49981 9.61661ZM7.49981 2.27495C8.98466 2.27495 9.982 3.39661 9.982 5.06557C9.982 6.87391 8.86847 8.34536 7.49981 8.34536C6.13116 8.34536 5.01763 6.87391 5.01763 5.06557C5.01763 3.39661 6.01517 2.27495 7.49981 2.27495ZM7.11895 11.0402H7.88047C11.4896 11.0402 13.9139 13.1785 13.9137 16.361C13.9137 16.7118 13.6364 16.9962 13.2944 16.9962C12.9519 16.9962 12.6746 16.7118 12.6746 16.361C12.6746 13.3718 10.0919 12.3114 7.88047 12.3114H7.11875C4.90733 12.3114 2.3252 13.3716 2.3252 16.361C2.3252 16.7118 2.04773 16.9962 1.70547 16.9962C1.36341 16.9962 1.08594 16.7118 1.08594 16.361C1.08594 13.1787 3.51044 11.0402 7.11895 11.0402Z",
                            fill: "#6F96D7"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M13.9137 16.361L13.7137 16.361V16.361H13.9137ZM11.0211 5.06578C11.0211 7.50421 9.40557 9.41661 7.49981 9.41661V9.81661C9.69799 9.81661 11.4211 7.6461 11.4211 5.06578H11.0211ZM7.49981 1.20391C8.5418 1.20391 9.41772 1.5998 10.0346 2.27307C10.6526 2.94763 11.0211 3.91264 11.0211 5.06578H11.4211C11.4211 3.82726 11.0244 2.76132 10.3295 2.00286C9.63343 1.24312 8.64873 0.803906 7.49981 0.803906V1.20391ZM3.97836 5.06578C3.97836 3.91264 4.34685 2.94764 4.96488 2.27308C5.58174 1.5998 6.45772 1.20391 7.49981 1.20391V0.803906C6.35079 0.803906 5.36605 1.24311 4.66996 2.00286C3.97504 2.76132 3.57836 3.82726 3.57836 5.06578H3.97836ZM7.49981 9.41661C5.59384 9.41661 3.97836 7.50421 3.97836 5.06578H3.57836C3.57836 7.64611 5.30144 9.81661 7.49981 9.81661V9.41661ZM10.182 5.06557C10.182 4.19182 9.9206 3.44381 9.44717 2.91149C8.9719 2.37711 8.29567 2.07495 7.49981 2.07495V2.47495C8.18879 2.47495 8.75366 2.73362 9.14828 3.17732C9.54472 3.62307 9.782 4.27037 9.782 5.06557H10.182ZM7.49981 8.54536C8.26063 8.54536 8.93558 8.13596 9.41363 7.50429C9.89165 6.87265 10.182 6.0094 10.182 5.06557H9.782C9.782 5.93008 9.51558 6.70673 9.09467 7.2629C8.67379 7.81904 8.10765 8.14536 7.49981 8.14536V8.54536ZM4.81763 5.06557C4.81763 6.0094 5.10797 6.87265 5.58599 7.50429C6.06404 8.13596 6.73899 8.54536 7.49981 8.54536V8.14536C6.89198 8.14536 6.32583 7.81904 5.90495 7.2629C5.48404 6.70673 5.21763 5.93008 5.21763 5.06557H4.81763ZM7.49981 2.07495C6.70405 2.07495 6.02782 2.37712 5.55254 2.91148C5.07908 3.4438 4.81763 4.19181 4.81763 5.06557H5.21763C5.21763 4.27038 5.45495 3.62308 5.85142 3.17732C6.24607 2.73361 6.81094 2.47495 7.49981 2.47495V2.07495ZM7.88047 10.8402H7.11895V11.2402H7.88047V10.8402ZM14.1137 16.361C14.1138 14.7157 13.4856 13.3297 12.3829 12.3571C11.2824 11.3865 9.72387 10.8402 7.88047 10.8402V11.2402C9.64619 11.2402 11.1044 11.7629 12.1183 12.6571C13.13 13.5494 13.7138 14.8238 13.7137 16.361L14.1137 16.361ZM13.2944 17.1962C13.7516 17.1962 14.1137 16.8175 14.1137 16.361H13.7137C13.7137 16.6062 13.5212 16.7962 13.2944 16.7962V17.1962ZM12.4746 16.361C12.4746 16.8176 12.8368 17.1962 13.2944 17.1962V16.7962C13.067 16.7962 12.8746 16.6061 12.8746 16.361H12.4746ZM7.88047 12.5114C8.95884 12.5114 10.1138 12.7707 10.9929 13.3797C11.8628 13.9822 12.4746 14.934 12.4746 16.361H12.8746C12.8746 14.7988 12.1951 13.7258 11.2207 13.0509C10.2556 12.3823 9.01352 12.1114 7.88047 12.1114V12.5114ZM7.11875 12.5114H7.88047V12.1114H7.11875V12.5114ZM2.5252 16.361C2.5252 14.9339 3.13691 13.9821 4.00659 13.3796C4.88557 12.7706 6.04038 12.5114 7.11875 12.5114V12.1114C5.9857 12.1114 4.74374 12.3823 3.7788 13.0508C2.80456 13.7257 2.1252 14.7987 2.1252 16.361H2.5252ZM1.70547 17.1962C2.16281 17.1962 2.5252 16.8176 2.5252 16.361H2.1252C2.1252 16.606 1.93266 16.7962 1.70547 16.7962V17.1962ZM0.885937 16.361C0.885937 16.8176 1.24829 17.1962 1.70547 17.1962V16.7962C1.47852 16.7962 1.28594 16.6061 1.28594 16.361H0.885937ZM7.11895 10.8402C5.27585 10.8402 3.71746 11.3866 2.61696 12.3572C1.51426 13.3298 0.885937 14.7158 0.885937 16.361H1.28594C1.28594 14.8239 1.86987 13.5495 2.88154 12.6572C3.89542 11.763 5.35355 11.2402 7.11895 11.2402V10.8402Z",
                            fill: "#6F96D7"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "",
                        placeholder: "Username"
                      },
                      domProps: { value: _vm.username },
                      on: {
                        change: _vm.changeUsername,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.invalidUsername.length
                    ? _c("p", { staticClass: "error-message" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M2.00146 2L9.99992 9.99845",
                                stroke: "#CE0000",
                                "stroke-width": "3",
                                "stroke-linecap": "round"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M9.99854 2L2.00008 9.99845",
                                stroke: "#CE0000",
                                "stroke-width": "3",
                                "stroke-linecap": "round"
                              }
                            })
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.invalidUsername) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "input-icon",
                        attrs: {
                          width: "15",
                          height: "18",
                          viewBox: "0 0 15 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d:
                              "M7.49981 9.61661C9.55178 9.61661 11.2211 7.57516 11.2211 5.06578C11.2211 2.67411 9.69072 1.00391 7.49981 1.00391C5.3087 1.00391 3.77836 2.67411 3.77836 5.06578C3.77836 7.57516 5.44764 9.61661 7.49981 9.61661ZM7.49981 2.27495C8.98466 2.27495 9.982 3.39661 9.982 5.06557C9.982 6.87391 8.86847 8.34536 7.49981 8.34536C6.13116 8.34536 5.01763 6.87391 5.01763 5.06557C5.01763 3.39661 6.01517 2.27495 7.49981 2.27495ZM7.11895 11.0402H7.88047C11.4896 11.0402 13.9139 13.1785 13.9137 16.361C13.9137 16.7118 13.6364 16.9962 13.2944 16.9962C12.9519 16.9962 12.6746 16.7118 12.6746 16.361C12.6746 13.3718 10.0919 12.3114 7.88047 12.3114H7.11875C4.90733 12.3114 2.3252 13.3716 2.3252 16.361C2.3252 16.7118 2.04773 16.9962 1.70547 16.9962C1.36341 16.9962 1.08594 16.7118 1.08594 16.361C1.08594 13.1787 3.51044 11.0402 7.11895 11.0402Z",
                            fill: "#6F96D7"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M13.9137 16.361L13.7137 16.361V16.361H13.9137ZM11.0211 5.06578C11.0211 7.50421 9.40557 9.41661 7.49981 9.41661V9.81661C9.69799 9.81661 11.4211 7.6461 11.4211 5.06578H11.0211ZM7.49981 1.20391C8.5418 1.20391 9.41772 1.5998 10.0346 2.27307C10.6526 2.94763 11.0211 3.91264 11.0211 5.06578H11.4211C11.4211 3.82726 11.0244 2.76132 10.3295 2.00286C9.63343 1.24312 8.64873 0.803906 7.49981 0.803906V1.20391ZM3.97836 5.06578C3.97836 3.91264 4.34685 2.94764 4.96488 2.27308C5.58174 1.5998 6.45772 1.20391 7.49981 1.20391V0.803906C6.35079 0.803906 5.36605 1.24311 4.66996 2.00286C3.97504 2.76132 3.57836 3.82726 3.57836 5.06578H3.97836ZM7.49981 9.41661C5.59384 9.41661 3.97836 7.50421 3.97836 5.06578H3.57836C3.57836 7.64611 5.30144 9.81661 7.49981 9.81661V9.41661ZM10.182 5.06557C10.182 4.19182 9.9206 3.44381 9.44717 2.91149C8.9719 2.37711 8.29567 2.07495 7.49981 2.07495V2.47495C8.18879 2.47495 8.75366 2.73362 9.14828 3.17732C9.54472 3.62307 9.782 4.27037 9.782 5.06557H10.182ZM7.49981 8.54536C8.26063 8.54536 8.93558 8.13596 9.41363 7.50429C9.89165 6.87265 10.182 6.0094 10.182 5.06557H9.782C9.782 5.93008 9.51558 6.70673 9.09467 7.2629C8.67379 7.81904 8.10765 8.14536 7.49981 8.14536V8.54536ZM4.81763 5.06557C4.81763 6.0094 5.10797 6.87265 5.58599 7.50429C6.06404 8.13596 6.73899 8.54536 7.49981 8.54536V8.14536C6.89198 8.14536 6.32583 7.81904 5.90495 7.2629C5.48404 6.70673 5.21763 5.93008 5.21763 5.06557H4.81763ZM7.49981 2.07495C6.70405 2.07495 6.02782 2.37712 5.55254 2.91148C5.07908 3.4438 4.81763 4.19181 4.81763 5.06557H5.21763C5.21763 4.27038 5.45495 3.62308 5.85142 3.17732C6.24607 2.73361 6.81094 2.47495 7.49981 2.47495V2.07495ZM7.88047 10.8402H7.11895V11.2402H7.88047V10.8402ZM14.1137 16.361C14.1138 14.7157 13.4856 13.3297 12.3829 12.3571C11.2824 11.3865 9.72387 10.8402 7.88047 10.8402V11.2402C9.64619 11.2402 11.1044 11.7629 12.1183 12.6571C13.13 13.5494 13.7138 14.8238 13.7137 16.361L14.1137 16.361ZM13.2944 17.1962C13.7516 17.1962 14.1137 16.8175 14.1137 16.361H13.7137C13.7137 16.6062 13.5212 16.7962 13.2944 16.7962V17.1962ZM12.4746 16.361C12.4746 16.8176 12.8368 17.1962 13.2944 17.1962V16.7962C13.067 16.7962 12.8746 16.6061 12.8746 16.361H12.4746ZM7.88047 12.5114C8.95884 12.5114 10.1138 12.7707 10.9929 13.3797C11.8628 13.9822 12.4746 14.934 12.4746 16.361H12.8746C12.8746 14.7988 12.1951 13.7258 11.2207 13.0509C10.2556 12.3823 9.01352 12.1114 7.88047 12.1114V12.5114ZM7.11875 12.5114H7.88047V12.1114H7.11875V12.5114ZM2.5252 16.361C2.5252 14.9339 3.13691 13.9821 4.00659 13.3796C4.88557 12.7706 6.04038 12.5114 7.11875 12.5114V12.1114C5.9857 12.1114 4.74374 12.3823 3.7788 13.0508C2.80456 13.7257 2.1252 14.7987 2.1252 16.361H2.5252ZM1.70547 17.1962C2.16281 17.1962 2.5252 16.8176 2.5252 16.361H2.1252C2.1252 16.606 1.93266 16.7962 1.70547 16.7962V17.1962ZM0.885937 16.361C0.885937 16.8176 1.24829 17.1962 1.70547 17.1962V16.7962C1.47852 16.7962 1.28594 16.6061 1.28594 16.361H0.885937ZM7.11895 10.8402C5.27585 10.8402 3.71746 11.3866 2.61696 12.3572C1.51426 13.3298 0.885937 14.7158 0.885937 16.361H1.28594C1.28594 14.8239 1.86987 13.5495 2.88154 12.6572C3.89542 11.763 5.35355 11.2402 7.11895 11.2402V10.8402Z",
                            fill: "#6F96D7"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fullname,
                          expression: "fullname"
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "",
                        placeholder: "Full name"
                      },
                      domProps: { value: _vm.fullname },
                      on: {
                        change: _vm.changeFullname,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.fullname = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.invalidFullname.length
                    ? _c("p", { staticClass: "error-message" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M2.00146 2L9.99992 9.99845",
                                stroke: "#CE0000",
                                "stroke-width": "3",
                                "stroke-linecap": "round"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M9.99854 2L2.00008 9.99845",
                                stroke: "#CE0000",
                                "stroke-width": "3",
                                "stroke-linecap": "round"
                              }
                            })
                          ]
                        ),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.invalidFullname) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "svg",
                {
                  staticClass: "input-icon",
                  attrs: {
                    width: "15",
                    height: "12",
                    viewBox: "0 0 16 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M1.4615 12H14.5392C15.3452 12 15.9998 11.3628 16 10.581V1.41793C16 0.635655 15.3452 0 14.5394 0H1.4615C0.654828 0 0 0.635655 0 1.41793V10.581C0 11.3628 0.654828 12 1.4615 12ZM1.4615 1.42811L14.5277 1.41811H14.5278V10.5717L1.47145 10.5812L1.4615 1.42811Z",
                      fill: "#6F96D7"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M7.99907 8C7.83687 8 7.67467 7.94124 7.54241 7.82567L1.25092 2.30059C0.952869 2.03722 0.9142 1.57316 1.16794 1.26278C1.41997 0.950436 1.86602 0.910904 2.16493 1.17445L7.99924 6.29993L13.8344 1.17445C14.1343 0.911082 14.5795 0.950436 14.8324 1.26278C15.0853 1.57316 15.0475 2.03722 14.7493 2.30059L8.45556 7.82567C8.32347 7.94124 8.16127 8 7.99907 8Z",
                      fill: "#6F96D7"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                staticClass: "input",
                attrs: {
                  type: "email",
                  name: "",
                  placeholder: "E-mail",
                  readonly: _vm.step === 1
                },
                domProps: { value: _vm.email },
                on: {
                  change: _vm.changeEmail,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.invalidEmail.length
              ? _c("p", { staticClass: "error-message" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2.00146 2L9.99992 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M9.99854 2L2.00008 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v(
                    "\n          " + _vm._s(_vm.invalidEmail) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 0
              ? _c("PasswordElemComponent", {
                  on: {
                    change: function($event) {
                      return _vm.changePassword($event)
                    }
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.invalidPassword.length
              ? _c("p", { staticClass: "error-message" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2.00146 2L9.99992 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M9.99854 2L2.00008 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v(
                    "\n          " + _vm._s(_vm.invalidPassword) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 0
              ? _c("p", { staticClass: "password-crieteria" }, [
                  _vm._v("\n          Password should contain: "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: _vm.passwordCriteria.hasMinLenght ? "green" : "red"
                    },
                    [_vm._v("at least 8 characters")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "span",
                    {
                      class: _vm.passwordCriteria.hasLowercase ? "green" : "red"
                    },
                    [_vm._v("1 lowercase letter")]
                  ),
                  _vm._v(", "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: _vm.passwordCriteria.hasUppercase ? "green" : "red"
                    },
                    [_vm._v("1 uppercase letter")]
                  ),
                  _vm._v(", and\n          "),
                  _c(
                    "span",
                    { class: _vm.passwordCriteria.hasNumber ? "green" : "red" },
                    [_vm._v("1 number")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 0
              ? _c(
                  "button",
                  {
                    staticClass: "login-submit",
                    attrs: { name: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.nextStep($event)
                      }
                    }
                  },
                  [_vm._v("\n          Sign up\n        ")]
                )
              : _c(
                  "button",
                  {
                    staticClass: "login-submit",
                    attrs: { type: "submit", name: "button" },
                    on: {
                      click: function($event) {
                        return _vm.submitForm($event)
                      }
                    }
                  },
                  [_vm._v("\n          Sign up\n        ")]
                ),
            _vm._v(" "),
            _vm.step === 0
              ? _c("div", { staticClass: "sign-up-terms" }, [
                  _c("div", { staticClass: "custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checkbox,
                          expression: "checkbox"
                        }
                      ],
                      staticClass: "custom-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.checkbox)
                          ? _vm._i(_vm.checkbox, null) > -1
                          : _vm.checkbox
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.checkbox,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.checkbox = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.checkbox = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.checkbox = $$c
                            }
                          },
                          _vm.changePolicy
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-checkbox-inner" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "from-terms__text" },
                    [
                      _vm._v(
                        "\n            By creating account I agree to the\n            "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "link",
                          attrs: { to: "/terms", target: "_blank" }
                        },
                        [_vm._v("User Agreement")]
                      ),
                      _vm._v("\n            and\n            "),
                      _c(
                        "router-link",
                        {
                          staticClass: "link",
                          attrs: { to: "/privacy-policy", target: "_blank" }
                        },
                        [_vm._v("Privacy Policy")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.invalidPolicy.length
              ? _c("p", { staticClass: "error-message" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2.00146 2L9.99992 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M9.99854 2L2.00008 9.99845",
                          stroke: "#CE0000",
                          "stroke-width": "3",
                          "stroke-linecap": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v(
                    "\n          " + _vm._s(_vm.invalidPolicy) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-facebook",
                on: {
                  click: function($event) {
                    return _vm.fbSignUp($event)
                  }
                }
              },
              [_vm._v("\n          Sign Up with Facebook\n        ")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "sign-up" }, [
              _vm._v("\n          Already have an account?\n          "),
              _c(
                "span",
                { staticClass: "sign-up-link", on: { click: _vm.backToLogin } },
                [_vm._v("Sign In")]
              )
            ])
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "divider" }, [
      _c("span", { staticClass: "divider-text" }, [_vm._v("OR")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }